// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for full-page contact form */
.PhysicianContactForm_contactForm__mD1b5 {
  position: relative;
  display: flex;
  justify-content: left;    /* center form horizontally */
  padding: 3rem 1rem;         /* ample vertical padding, narrow sides */
  box-sizing: border-box;
  color: #aab5b7;
}

/* Overlay loader */
.PhysicianContactForm_overlay__Z6-XK {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(17, 17, 17, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 1em;
}

/* Form section wrapper */
.PhysicianContactForm_contactFormFormSection__GlsoX {
  width: 100%;
  max-width: 420px;           /* constrain width */
  display: flex;
  flex-direction: column;
  gap: 1rem;                  /* uniform spacing */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Labels */
.PhysicianContactForm_label__J5H0W {
  margin: 0 0 0.25rem;
  color: #ffffff;
  font-size: 0.9rem;
}

/* Inputs, selects, textarea styling */
.PhysicianContactForm_contactFormFormControl__vuGJS,
.PhysicianContactForm_contactFormFormSelect__VOPoI,
textarea {
  width: 100%;
  border-radius: 1.5em;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 0.75em 1em;
  background-color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

/* Placeholder color */
.PhysicianContactForm_contactFormFormControl__vuGJS::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

/* Focus state */
.PhysicianContactForm_contactFormFormControl__vuGJS:focus,
.PhysicianContactForm_contactFormFormSelect__VOPoI:focus {
  outline: none;
  border-color: #aab5b7;
}

/* Required asterisk */
.PhysicianContactForm_contactFormTextDanger__WDWns {
  color: #ff6b6b !important;
  font-weight: 600;
  font-size: 0.85rem;
}

/* Submit button */
.PhysicianContactForm_contactFormFormSubmit__xkzbF {
  align-self: center;         /* center under fields */
  width: 100%;                /* full width of form wrapper */
  padding: 0.75em 0;
  background-color: #ffffff !important;
  color: #111 !important;
  border: none !important;
  border-radius: 2em !important;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Submit hover */
.PhysicianContactForm_contactFormFormSubmit__xkzbF:hover {
  background-color: #dcd5d5 !important;
  transform: translateY(-1px);
}

/* Toast body */
.PhysicianContactForm_toast-body__x\\+X\\+n {
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .PhysicianContactForm_contactForm__mD1b5 {
    padding: 2rem 0.5rem;
  }
  .PhysicianContactForm_contactFormFormSection__GlsoX {
    max-width: 100%;
    gap: 0.75rem;
  }
  .PhysicianContactForm_contactFormFormControl__vuGJS,
  .PhysicianContactForm_contactFormFormSelect__VOPoI,
  textarea {
    font-size: 0.85rem;
    padding: 0.6em 0.8em;
  }
  .PhysicianContactForm_contactFormFormSubmit__xkzbF {
    padding: 0.6em 0;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FORM/PHYSICIAN_CONTACT/PhysicianContactForm.module.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB,KAAK,6BAA6B;EACvD,kBAAkB,UAAU,yCAAyC;EACrE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB,YAAY,oBAAoB;EAChD,aAAa;EACb,sBAAsB;EACtB,SAAS,mBAAmB,oBAAoB;EAChD,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;;;EAGE,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,UAAU,wBAAwB;EACpD,WAAW,iBAAiB,+BAA+B;EAC3D,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;;;IAGE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":["/* Container for full-page contact form */\n.contactForm {\n  position: relative;\n  display: flex;\n  justify-content: left;    /* center form horizontally */\n  padding: 3rem 1rem;         /* ample vertical padding, narrow sides */\n  box-sizing: border-box;\n  color: #aab5b7;\n}\n\n/* Overlay loader */\n.overlay {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: rgba(17, 17, 17, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  border-radius: 1em;\n}\n\n/* Form section wrapper */\n.contactFormFormSection {\n  width: 100%;\n  max-width: 420px;           /* constrain width */\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;                  /* uniform spacing */\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Labels */\n.label {\n  margin: 0 0 0.25rem;\n  color: #ffffff;\n  font-size: 0.9rem;\n}\n\n/* Inputs, selects, textarea styling */\n.contactFormFormControl,\n.contactFormFormSelect,\ntextarea {\n  width: 100%;\n  border-radius: 1.5em;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  padding: 0.75em 1em;\n  background-color: rgba(255, 255, 255, 0.9);\n  font-size: 0.9rem;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n}\n\n/* Placeholder color */\n.contactFormFormControl::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n/* Focus state */\n.contactFormFormControl:focus,\n.contactFormFormSelect:focus {\n  outline: none;\n  border-color: #aab5b7;\n}\n\n/* Required asterisk */\n.contactFormTextDanger {\n  color: #ff6b6b !important;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n/* Submit button */\n.contactFormFormSubmit {\n  align-self: center;         /* center under fields */\n  width: 100%;                /* full width of form wrapper */\n  padding: 0.75em 0;\n  background-color: #ffffff !important;\n  color: #111 !important;\n  border: none !important;\n  border-radius: 2em !important;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n/* Submit hover */\n.contactFormFormSubmit:hover {\n  background-color: #dcd5d5 !important;\n  transform: translateY(-1px);\n}\n\n/* Toast body */\n.toast-body {\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n/* Responsive tweaks */\n@media (max-width: 768px) {\n  .contactForm {\n    padding: 2rem 0.5rem;\n  }\n  .contactFormFormSection {\n    max-width: 100%;\n    gap: 0.75rem;\n  }\n  .contactFormFormControl,\n  .contactFormFormSelect,\n  textarea {\n    font-size: 0.85rem;\n    padding: 0.6em 0.8em;\n  }\n  .contactFormFormSubmit {\n    padding: 0.6em 0;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactForm": `PhysicianContactForm_contactForm__mD1b5`,
	"overlay": `PhysicianContactForm_overlay__Z6-XK`,
	"contactFormFormSection": `PhysicianContactForm_contactFormFormSection__GlsoX`,
	"label": `PhysicianContactForm_label__J5H0W`,
	"contactFormFormControl": `PhysicianContactForm_contactFormFormControl__vuGJS`,
	"contactFormFormSelect": `PhysicianContactForm_contactFormFormSelect__VOPoI`,
	"contactFormTextDanger": `PhysicianContactForm_contactFormTextDanger__WDWns`,
	"contactFormFormSubmit": `PhysicianContactForm_contactFormFormSubmit__xkzbF`,
	"toast-body": `PhysicianContactForm_toast-body__x+X+n`
};
export default ___CSS_LOADER_EXPORT___;
